import React, { useState } from 'react';
import Url from '../../global/Url';
import '../home/home.css';
import './consulta.css';

const Field = ({ icon, label, value }) => (
  <div className="consulta-field">
    <span className="consulta-field__label"><i className={`bi ${icon}`}></i> {label}</span>
    <span className="consulta-field__value">{value || '—'}</span>
  </div>
);

const formatFecha = (v) => {
  if (!v) return '';
  return String(v).replace('T', ' ').slice(0, 19);
};

const Consulta = () => {
  const [numero, setNumero] = useState('');
  const [loading, setLoading] = useState(false);
  const [resultado, setResultado] = useState(null);
  const [error, setError] = useState('');
  const [buscado, setBuscado] = useState(false);
  const [canal, setCanal] = useState(''); // '', 'fusion' o 'dragon'

  // El canal del registro sale del database_name (= "Leads Fusion" → Fusión; otro → Dragon).
  const esFusion = (l) => String(l.campania || '').trim().toLowerCase() === 'leads fusion';
  const canalDe = (l) => (esFusion(l) ? 'Fusión' : 'Dragon');

  const consultar = async () => {
    if (numero.trim().length < 7) {
      setError('Ingrese un número válido (mínimo 7 dígitos).');
      return;
    }
    setError('');
    setLoading(true);
    setBuscado(true);
    try {
      const res = await fetch(`${Url.Api}consultaLead/${numero.trim()}`);
      const json = await res.json();
      setResultado(json);
    } catch (e) {
      setError('No se pudo realizar la consulta. Intente nuevamente.');
      setResultado(null);
    } finally {
      setLoading(false);
    }
  };

  const onKeyDown = (e) => {
    if (e.key === 'Enter') consultar();
  };

  const leads = resultado?.leads || [];
  const leadsFiltrados = leads.filter((l) =>
    canal === '' ? true : canal === 'fusion' ? esFusion(l) : !esFusion(l)
  );

  return (
    <div className="home-wrap">
      {/* Buscador */}
      <section className="lead-card mb-4">
        <div className="lead-card__header">
          <i className="bi bi-search"></i>
          <h2 className="lead-card__title">Consulta de leads</h2>
        </div>
        <div className="lead-card__body">
          <label className="lead-label">Número de teléfono</label>
          <div className="input-group consulta-search">
            <span className="input-group-text"><i className="bi bi-telephone"></i></span>
            <input
              type="text"
              className="form-control"
              placeholder="Ingrese el número a consultar"
              value={numero}
              maxLength={10}
              onChange={(e) => setNumero(e.target.value.replace(/\D/g, ''))}
              onKeyDown={onKeyDown}
            />
            <button className="btn lead-btn-ingresar" onClick={consultar} disabled={loading}>
              {loading ? 'Consultando…' : 'Consultar'}
            </button>
          </div>
          <div className="consulta-canal">
            <label className="lead-label"><i className="bi bi-diagram-3"></i> Canal</label>
            <select className="form-select" value={canal} onChange={(e) => setCanal(e.target.value)}>
              <option value="">Todos</option>
              <option value="dragon">Lead Dragon</option>
              <option value="fusion">Lead Fusión</option>
            </select>
          </div>
          {error && <p className="consulta-error">{error}</p>}
        </div>
      </section>

      {/* Resultado */}
      {buscado && !loading && (
        <section className="lead-card">
          <div className="lead-card__header lead-card__header--toolbar">
            <div className="lead-card__title-wrap">
              <i className="bi bi-person-vcard"></i>
              <h2 className="lead-card__title">Resultado</h2>
            </div>
            {leadsFiltrados.length > 0 && (
              <span className="consulta-count">
                {leadsFiltrados.length} registro(s) para {resultado.phone}
              </span>
            )}
          </div>
          <div className="lead-card__body">
            {leadsFiltrados.length === 0 ? (
              <div className="consulta-empty">
                <i className="bi bi-inbox"></i>
                <p>{leads.length === 0 ? 'No se encontró información para este número.' : 'Sin registros de este canal para el número.'}</p>
              </div>
            ) : (
              leadsFiltrados.map((l, i) => (
                <div className="consulta-result" key={i}>
                  <div className="consulta-result__head">
                    <span className="consulta-result__name">{l.client_name || 'Sin nombre'}</span>
                    <span className="consulta-result__canales">
                      <span className={`lead-badge ${esFusion(l) ? 'lead-badge--warning' : 'lead-badge--info'}`}>{canalDe(l)}</span>
                      <span className={`lead-badge ${l.status ? 'lead-badge--info' : 'lead-badge--default'}`}>
                        {l.status || 'Sin estado'}
                      </span>
                    </span>
                  </div>
                  <div className="consulta-grid">
                    <Field icon="bi-telephone" label="Número" value={l.phone} />
                    <Field icon="bi-card-text" label="Identificación" value={l.client_identification} />
                    <Field icon="bi-person" label="Cliente" value={l.client_name} />
                    <Field icon="bi-geo-alt" label="Ciudad" value={l.client_city} />
                    <Field icon="bi-tag" label="Tarifa" value={l.client_tariff} />
                    <Field icon="bi-megaphone" label="Campaña / Base" value={l.campania} />
                    <Field icon="bi-list-ul" label="Cola" value={l.cola} />
                    <Field icon="bi-calendar3" label="Fecha" value={formatFecha(l.created_at)} />
                  </div>
                </div>
              ))
            )}
          </div>
        </section>
      )}
    </div>
  );
};

export default Consulta;
